import React from 'react';

import {Anchor, IconButton, Popover, Text} from '@albert-io/atomic';
import {useHoverPopover} from 'lib/hooks/useHoverPopover';

import {SyncStatusOverlay} from './SyncStatusOverlay';
import {LMS_SYNC_POPOVER_CONTENT_CLASS, LMS_SYNC_POPOVER_POSITION} from './lmsSyncConfig';

const ANCHOR_TEXT = 'Learn how to connect tools like Canvas, Schoology, etc';

interface Props {
  /** Platform-specific help URL for connecting the LMS course. */
  ltiPlatformHelpLink: string;
}

/**
 * Can't-sync affordance (mirrors YourFiltersInfoPopover): a muted slashed-sync trigger that opens an
 * interactive hover popover with a help link, hover-bridged via useHoverPopover so the cursor can
 * cross onto the popover to click the link.
 */
export const CantSyncInfoPopover = ({ltiPlatformHelpLink}: Props) => {
  const {isOpen, triggerRef, triggerProps, contentProps} = useHoverPopover();

  return (
    <>
      <IconButton
        {...triggerProps}
        icon='arrows-rotate'
        iconStyle='regular'
        label='Cannot sync grades'
        size='s'
        className='relative'
        iconProps={{color: 'tertiary'}}
      >
        <SyncStatusOverlay status='blocked' />
      </IconButton>
      {isOpen && (
        <Popover
          targetRef={triggerRef}
          expanded
          position={LMS_SYNC_POPOVER_POSITION}
          paddingLevel={0}
          roundness='small'
          className='background-primary-inverse!'
        >
          <div className={LMS_SYNC_POPOVER_CONTENT_CLASS} {...contentProps}>
            <Text size='s' color='primary-inverse' className='leading-[1.4]'>
              {'Cannot Sync Grades. Classrooms not connected. '}
              <Anchor
                className='content-primary-inverse!'
                underlined
                target='_blank'
                to={ltiPlatformHelpLink}
              >
                {ANCHOR_TEXT}
              </Anchor>
            </Text>
          </div>
        </Popover>
      )}
    </>
  );
};
